import * as React from 'react';

function SvgEmojiWinkFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 0a8 8 0 110 16A8 8 0 018 0zM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zM4.285 9.567a.5.5 0 00-.183.683A4.498 4.498 0 008 12.5a4.5 4.5 0 003.898-2.25.5.5 0 10-.866-.5A3.498 3.498 0 018 11.5a3.498 3.498 0 01-3.032-1.75.5.5 0 00-.683-.183zm5.152-3.31a.5.5 0 00-.874.486c.33.595.958 1.007 1.687 1.007.73 0 1.356-.412 1.687-1.007a.5.5 0 00-.874-.486.934.934 0 01-.813.493.934.934 0 01-.813-.493z' />
		</svg>
	);
}

export default SvgEmojiWinkFill;
